// GENERATED FILE - do not edit. Generated by tools/set-env.js from environment.template.ts + artflow-ui-v002.demo.env

export const environment = {
  production: true,
  BASE_API_PATH: 'https://api-demo.artflow-pro.com/api',
  portalUrl: 'https://demo.portal.artflow-pro.com',
  // Build stamp — injected by tools/set-env.js (build number auto-increments on build).
  build: {
    version: '1.02',
    number: '56',
    timestamp: '2026-07-30T02:27:16.970Z',
    commit: '4cec626'
  },
  REFRESH_TOKEN_X_SECONDS_BEFORE_EXPIRY: 30,
  CHECK_TOKEN_REFRESH_AFTER_X_SECONDS: 30,
  firebase: {
    apiKey: "AIzaSyDBiL6Zt4rjZRZ8IMVPmbxto1O8kSjVHDI",
    authDomain: "artflow-mobile-app.firebaseapp.com",
    projectId: "artflow-mobile-app",
    storageBucket: "artflow-mobile-app.appspot.com",
    messagingSenderId: "131535910811",
    appId: "1:131535910811:web:6113f139d82c8d8832d33e",
    measurementId: "G-R97QDKYEBQ"
  },
  mapbox: {
    accessToken: 'pk.eyJ1Ijoic2FoaWwtMDMiLCJhIjoiY21pbTMybjczMWY5eDNlcjQxcnVkYjNhNyJ9.UX46nu-NiTUCyDS-ppnXqw'
  },
  // Bria.ai API for AI background generation
  briaApiKey: 'b3fa51d5ef5d4bdc88246f93af77fc3c'
}
